import { RootState } from '../types'

export const getRolesSelector = (state: RootState) => state.role.roles

export const getMainRoleSelector = (state: RootState) => state.role
